import { getAuthToken } from '~/src/dash/resellers/utils/importResellerConfig';

export function setToken(json: any): any {
  return localStorage.setItem(getAuthToken(), JSON.stringify(json));
}

export function getToken(): unknown {
  return JSON.parse(localStorage.getItem(getAuthToken()) || '{}');
}
